export class ContractConcession {
    public id?: string;
    contractId?: string;
    public area?: number;
    public price?: number;
    public percentageDiscount?: number;
    priceIndex?: number;
    startDate?: string | null;
    // public userName?: string;
    isFittedOutArea?: boolean | string;
    isGoodAccessibility?: boolean | string;
    zone?: string | null;

    constructor(contractConcession?: ContractConcession) {
        this.id = contractConcession?.id;
        this.contractId = contractConcession?.contractId;
        this.area = contractConcession?.area;
        this.price = contractConcession?.price;
        this.percentageDiscount = contractConcession?.percentageDiscount;
        this.priceIndex = contractConcession?.priceIndex;
        this.startDate = contractConcession?.startDate;
        // this.userName = contractConcession?.userName;
        this.isFittedOutArea = (typeof contractConcession?.isFittedOutArea == "string")
            ? ((contractConcession?.isFittedOutArea || "").toLowerCase() == "true")
            : contractConcession?.isFittedOutArea;
        this.isGoodAccessibility = (typeof contractConcession?.isGoodAccessibility == "string")
            ? ((contractConcession?.isGoodAccessibility || "").toLowerCase() == "true")
            : contractConcession?.isGoodAccessibility;
        this.zone = contractConcession?.zone;

    }
}
